import styled from 'styled-components'

export const TextLimiter = styled.div`
  display: ${(props) => props.showFullText ? null : '-webkit-box'};
  -webkit-line-clamp: ${(props) => props.limitText ? props.limitText : '1'};
  word-break: ${(props) => props.limitText > 1 ? 'normal' : 'break-all'};
  -webkit-box-orient: vertical;
  overflow: hidden;
`